import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { appRoutes } from './app.routes';
import { EnvironmentResolver } from './core/environment-resolver';

const initializeEnvironment = (environmentResolver: EnvironmentResolver) => async (): Promise<void> => {
    await environmentResolver.setEnvironment();
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes),
        provideAnimations(),
        provideHttpClient(),
        {
            provide: APP_INITIALIZER,
            useFactory: initializeEnvironment,
            multi: true,
            deps: [EnvironmentResolver]
        }
    ]
};
